module.exports = require('../manifest.json').version



//////////////////
// WEBPACK FOOTER
// ./~/youboralib/src/version.js
// module id = 10
// module chunks = 0